import { render } from "./calibrate.vue?vue&type=template&id=4979e155&scoped=true"
import script from "./calibrate.vue?vue&type=script&lang=js"
export * from "./calibrate.vue?vue&type=script&lang=js"

import "./calibrate.vue?vue&type=style&index=0&id=4979e155&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4979e155"]])

export default __exports__